// js
import engagementCompositeForm from './engagementCompositeForm';
import EngagementSplunkItem from './EngagementSplunkItem';


export default engagementCompositeForm({
  title: 'Splunk',
  className: 'analytics__engagement-splunk-form',
  displayName: 'EngagementSplunkForm',
  itemComponent: EngagementSplunkItem
});



// WEBPACK FOOTER //
// ./src/components/analytics/EngagementSplunkForm.js